import { API_AUTH } from "./common";

const ThuocTinhGiamTruApi = {
    danhsachcauhinhtaisan:()=> API_AUTH.get(`ThuocTinhGiamTru/GetAllCauHinhTaiSan`,{}),
    getDataByCauHinhTaiSanID: ({id})=>API_AUTH.get(`ThuocTinhGiamTru/GetDataByCauHinhTaiSanID?CauHinhTaiSanId=${id}`,{}),
    deleteHangSanXuat: ({id}) => API_AUTH.post(`ThuocTinhGiamTru/DeleteHangSanXuatByID?id=${id}`, {}),
    addoreditHangSanXuat: (data)=>API_AUTH.post(`ThuocTinhGiamTru/AddOrEditHangSanXuat`,data),
    deleteDongSanPham: ({id}) => API_AUTH.post(`ThuocTinhGiamTru/DeleteDongSanPhamByID?id=${id}`, {}),
    addoreditDongSanPham: (data)=>API_AUTH.post(`ThuocTinhGiamTru/AddOrEditDongSanPham`,data),
    getListHangSanXuatByCauHinhTaiSanID: ({id}) => API_AUTH.get(`ThuocTinhGiamTru/GetHangSanXuatByCauHinhTaiSanID?id=${id}`,{}),
    deleteThuocTinhGiamTru: ({id}) => API_AUTH.post(`ThuocTinhGiamTru/DeleteThuocTinhGiamTruByID?id=${id}`, {}),
    addoreditThuocTinhGiamTru: (data)=>API_AUTH.post(`ThuocTinhGiamTru/AddOrEditThuocTinhGiamTru`,data),
}

export default ThuocTinhGiamTruApi;